import React from 'react'
import Uppy from '@uppy/core'
import { DragDrop, ProgressBar } from '@uppy/react'
import { Toast } from '../index'
import '@uppy/core/dist/style.css'
import '@uppy/drag-drop/dist/style.css'
import '@uppy/progress-bar/dist/style.css'
import { DragDropContainer } from './styled'

const Upload = ({
  uppyId,
  fileInfo,
  updateFileInfo,
  allowedFileTypes = ['.xlsx'],
}) => {
  const uppy = new Uppy({
    restrictions: { maxNumberOfFiles: 1, allowedFileTypes },
    autoProceed: true,
    onBeforeFileAdded: (currentFile) => {
      if (allowedFileTypes.indexOf(currentFile.name) === -1) {
        Toast.error('文件格式错误，无法上传')
      }
    },
  })
  uppy.on('file-added', (file) => {
    updateFileInfo(file)
  })

  return (
    <>
      <DragDropContainer className="ml-8 relative">
        <DragDrop
          id={uppyId}
          uppy={uppy}
          locale={{
            strings: {
              dropHereOr: '点击或将文件%{browse}到这里上传',
              browse: '拖拽',
            },
          }}
          height={150}
          width={240}
        />
      </DragDropContainer>
      <ProgressBar uppy={uppy} hideAfterFinish={false} />
      {fileInfo && fileInfo.name && (
        <div
          className="ml-8 text-blue-1 mt-1"
          style={{ fontSize: '0.75rem', zIndex: 1000 }}
        >
          已选择文件: {fileInfo.name}
          <span
            className="ml-2 text-red-500 cursor-pointer"
            onClick={() => {
              uppy.removeFile(fileInfo.id)
              updateFileInfo(null)
            }}
          >
            删除
          </span>
        </div>
      )}
    </>
  )
}

export default Upload
